import Elements from './elements';
import Layouts from './layouts';
import Icons from './icons';
import Controls from './controls';
import Charts from './charts';

export default {
    Elements,
    Layouts,
    Icons,
    Controls,
    Charts
}